module.exports = __webpack_public_path__ + "img/boter-in-kom-bloem-in-zeef.c44e5b88.jpg";